import Verify from "@/components/verifition/Verify";
export default {
  name: "login-password-type",
  components: {
    Verify
  },
  props: {
    data: {
      // password-密码， code-验证码
      type: Object,
      default() {
        return {};
      }
    },
    // 初始倒计时时间（秒）
    initialCountdown: {
      type: Number,
      default: 59
    },
    // 登录页可传入更友好的必填提示，未传入时保留通用密码表单文案。
    passwordRequiredMessage: {
      type: String,
      default: $t("c2r1q94", "密码必填")
    }
  },
  data() {
    return {
      countdown: 0,
      countdownTimer: null,
      ruleValidate: {
        password: [{
          required: true,
          message: this.passwordRequiredMessage,
          trigger: "blur,change"
        }],
        verificationCode: [{
          required: true,
          message: $t("gvicb25", "验证码必填"),
          trigger: "blur,change"
        }, {
          pattern: /\d{6}/,
          message: $t("hf7bgs8", "验证码为6位数字"),
          trigger: "blur,change"
        }]
      }
    };
  },
  methods: {
    onChange(type) {
      let emitValue = {
        type
      };
      this.$emit("on-change", emitValue);
    },
    handleInputPassword(value) {
      let emitValue = {
        password: value
      };
      this.$emit("on-change", emitValue);
    },
    handleInputCode(value) {
      let emitValue = {
        verificationCode: value
      };
      this.$emit("on-change", emitValue);
    },
    handleEnter() {
      this.$emit("on-enter");
    },
    getCode() {
      this.$refs.verifyPassword.show();
    },
    onSuccessVerify(value) {
      this.$emit("on-send-verify", value, () => {
        this.startCountdown();
      });
    },
    // 开始倒计时
    startCountdown() {
      this.countdown = this.initialCountdown;
      this.countdownTimer = setInterval(() => {
        this.countdown--;
        if (this.countdown <= 0) {
          clearInterval(this.countdownTimer);
        }
      }, 1000);
    },
    // 处理重新发送
    handleResend() {
      if (this.countdown > 0) return;

      // 触发重新发送事件
      this.startCountdown();
    },
    beforeDestroy() {
      // 清除定时器
      if (this.countdownTimer) {
        clearInterval(this.countdownTimer);
      }
    },
    validPassword() {
      return this.$refs.formPassword.validate;
    },
    validCode() {
      return this.$refs.formCode.validate;
    }
  }
};